import type { AdminSectionProps } from './types'
import { CashierPolicySection } from './CashierPolicySection'
import { OrgProfileSection } from './OrgProfileSection'
import { AdminCard } from './AdminCard'
import { useAuthToken } from './useAuthToken'

/**
 * Раздел «Организация» — композиция: реквизиты и торговые точки + политика
 * кассы. Реквизиты нужны чаще, поэтому они развёрнуты и стоят первыми.
 */
export function OrganizationSection({ core }: AdminSectionProps) {
  const token = useAuthToken()
  return (
    <>
      <AdminCard
        id="org.profile"
        title="Реквизиты организации и торговые точки"
        defaultOpen
      >
        <OrgProfileSection token={token} />
      </AdminCard>

      <AdminCard id="org.policy" title="Политика кассы">
        <CashierPolicySection core={core} />
      </AdminCard>
    </>
  )
}
